import * as React from "react";
import { Button, withStyles } from "@material-ui/core";
import { LoginStore } from "modules/login/LoginStore";
import { ProfileStore } from "modules/profile/ProfileStore";
import { WBSStore } from "modules/WBS/WBSStore";
import i18n from "i18n";

const styles = () => ({
  trialBar: {
    backgroundColor: "#E5E5E5",
    display: "flex",
    flexWrap: "nowrap" as any,
    justifyContent: "space-evenly",
    alignItems: "center",
    padding: "0px 60px",
  },
  btnSubscribeNow: {
    backgroundColor: "#9AAF00",
    padding: "4px 12px",
    fontSize: "14px",
    lineHeight: "16px",
    "&:hover": {
      backgroundColor: "#92A501",
    },
  },
});

const TrialBanner = ({ classes }) => {
  const show = LoginStore.isTrialUser();

  if (!show) return <></>;

  const message = i18n.trialRegister.trialEexpiresIn;
  const days = LoginStore.timeLeft();

  return (
    <div className={classes.trialBar}>
      {createLabel(days, message)}
      <Button
        className={classes.btnSubscribeNow}
        onClick={() => WBSStore.subscribeShowChange(true)}
      >
        {i18n.trialRegister.subscribeNow02}
      </Button>
    </div>
  );
};

function createLabel(days: number, message: string) {
  let msg = message.split("%s");
  let dayLabel = `${days} ` + i18n.day + (days === 1 ? "" : "s");
  return (
    <p>
      {msg[0]}
      <b>{dayLabel}</b>
      {msg[1]}
    </p>
  );
}

export default withStyles(styles)(TrialBanner);



// WEBPACK FOOTER //
// ./src/modules/project/components/layouts/TrialBanner.tsx